<template>
  <transition class="font-poppins" name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal w-1/3 md:w-full rounded-lg"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header text-center"
          id="modalTitle"
        >
          <slot name="header">
            Error
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
        </header>

        <section
          class="modal-body text-center "
          id="modalDescription"
        >
          <slot name="body">
            <p class="text-2xl">Opps... Something went wrong.</p>
            <p>{{message}}</p>
            <p>{{incorrectPassword}}</p>

          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            
          </slot>
          <div class="flex justify-center">
            
            <button
                type="button"
                class="bg-blue-700 border p-2 rounded-lg w-1/2"
                @click="close"
                aria-label="Close modal"
            >
                OK
            </button>
          </div>
          
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'errorModal',
    props: ["message", "incorrectPassword"],

    methods: {
      close() {
        this.$emit('close');
      }, 
    },
  };
</script>

<style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>